// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1_jZ2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__LogTs","obliqueLine":"membershipbadge_obliqueLine__-eTgO"};